import { strRemoveSpaces, translation as t } from "../../../../inc/helpers";
import Input from "./Input";

export default class InputRadio extends Input {
    constructor({ container, label, error }) {
        super({
            container,
            label,
            error,
        });

        this._inputs = Array.from(this._container.querySelectorAll(".input-radio"));
        this._value =
            this._inputs.find(
                (input) => input.getAttribute("aria-checked") === "true"
            )?.dataset?.value ?? null;
        this._values = this._inputs.map((input) => input.dataset.value);

        this._inputCurrOnChecked = [];
    }

    initEvs() {
        this._evOnChange = (e) => this.onChange(e);
        this._evOnBlur = (e) => this.onBlur(e);

        this._inputs.forEach((input) => {
            input.addEventListener("click", this._evOnChange);
            input.addEventListener("blur", this._evOnBlur);
        });
        this._container.addEventListener("keydown", this._evOnChange);
        this._container.addEventListener("blur", this._evOnBlur);
    }

    onChange(e) {
        if (this._readonly || this._disabled) return;

        if (e.type === "keydown") {
            if (e.key === " ") e.preventDefault();
            else return;
        }

        let value = e.target.dataset?.value;
        if (value === undefined)
            value = e.target.closest(".input-radio").dataset.value;

        if (this._value === value)
            return;

        this._value =
            this._values.includes(value)
                ? value
                : null;
        this._valid = this._validate(this._value);
        this.handleChange();
        this.toggleValidation();

        if (this._inputCurrOnChecked.length > 0)
            this._cbackControls?.(this._inputCurrOnChecked, this);

        if (this._onchange?.length > 0)
            this._cbackControls?.(this._onchange, this);

        if (this._valid.flag === null) return;

        if (this._valid.flag && (this._onvalid?.length > 0)) {
            this._cbackControls?.(this._onvalid, this);

        } else if (!this._valid.flag && (this._oninvalid.length > 0)) {
            this._cbackControls?.(this._oninvalid, this);
        }

        this.handleDispatch();
    }

    onBlur(e) {
        if (this._readonly || this._disabled)
            return;

        const prev = this._inputs.includes(e.relatedTarget);
        if (prev) return;

        this._valid = this._validate(this._value);
        this.toggleValidation();

        if (this._valid.flag === null) return;

        if (this._valid.flag && (this._onvalid?.length > 0)) {
            this._cbackControls?.(this._onvalid, this);

        } else if (!this._valid.flag && (this._oninvalid.length > 0)) {
            this._cbackControls?.(this._oninvalid, this);
        }

        this.handleDispatch();
    }

    _validate(value) {
        if (this._required && !value) {
            return { flag: false, msg: t("ERROR.FieldMandatory") };

        } else if (!this._required && value) {
            return { flag: true, msg: "" };

        } else if (this._required && value) {
            return { flag: true, msg: "" };
        }

        return { flag: null, msg: "" };
    }

    handleChange() {
        this.uncheckInputPrev();
        this.checkInputCurr();
    }

    uncheckInputPrev() {
        const prev = this._inputs.find(
            (input) => input.getAttribute("aria-checked") === "true"
        );
        prev?.setAttribute("aria-checked", "false");
    }

    checkInputCurr() {
        const curr = this._inputs.find(
            (input) => input.getAttribute("data-value") === this._value
        );
        curr?.setAttribute("aria-checked", "true");

        const controls = curr?.dataset?.controls
            ? curr?.dataset?.controls.split(",").map((name) => name.trim())
            : [];
        const onchecked = curr?.dataset?.onChecked
            ? this.setupActions(strRemoveSpaces(curr.dataset.onChecked), controls)
            : [];
        this._inputCurrOnChecked = onchecked.length > 0 ? onchecked : [];
    }

    reset() {
        super.reset();
        this.handleChange();
    }

    get value() {
        return this._value;
    }

    set value(value) {        
        this._value = value;
        this._valid = this._validate(this._value);

        this.handleChange();
        this.toggleValidation();
    }

    get values() {
        return this._values;
    }

    set values(arr) {
        if (!Array.isArray(arr))
            return;

        this._values = [...arr];
    }
}